// extracted by mini-css-extract-plugin
export default {"card":"ImgCard_card__PvUus","card-wrapper":"ImgCard_card-wrapper__++bGt","closeBtn":"ImgCard_closeBtn__Pi-9l","error":"ImgCard_error__vlwXY"};